// extracted by mini-css-extract-plugin
export var chosenSolution = "index-module--chosenSolution--G57QY";
export var imgContent = "index-module--imgContent--Z4sC0";
export var inner = "index-module--inner--adpZO";